import React from 'react';
import { useTranslation } from 'react-i18next';

export interface PlatformCap {
  platform: string;
  cap: number;
}

interface MultiImagesHintProps {
  count: number;
  minCap: number;
  selectedCaps: PlatformCap[];
}

export const MultiImagesHint: React.FC<MultiImagesHintProps> = ({ count, minCap, selectedCaps }) => {
  const { t } = useTranslation();
  if (selectedCaps.length > 0) {
    if (count > minCap) {
      const list = selectedCaps.map(({ platform, cap }) => `${platform}: ${cap}`).join(', ');
      return (
        <div className="text-xs text-orange-700 bg-orange-50 border border-orange-200 rounded px-2 py-1 text-center">
          {t('warnings.multiImagesCap', 'You selected {{count}} images. Current platform limits, {{list}}.', { count, list })}
        </div>
      );
    }
    return null;
  }
  if (count > 20) {
    return (
      <div className="text-xs text-orange-700 bg-orange-50 border border-orange-200 rounded px-2 py-1 text-center">
        {t('warnings.instagramCap', 'Instagram carousel supports up to 20 images.')}
      </div>
    );
  }
  return null;
};


